import {
  IQuoteRespSchema,
  QuoteOfferingProps,
  QuoteOfferingWithChildren,
} from '@monetize/types/app';
import { MBox } from '../../../components/Monetize';
import QuoteOffering from './components/quoteOffering/QuoteOffering';
import { QuoteFormOfferingTableHeader } from './QuoteFormOfferingTableHeader';
import type { JSX } from 'react';

interface QuoteFormOfferingRowProps extends Pick<
  QuoteOfferingProps,
  'onChange' | 'quotePrices'
> {
  quoteOfferings: QuoteOfferingWithChildren[];
  quote?: IQuoteRespSchema | null;
  renderQuoteOfferings: (
    quoteOfferings: QuoteOfferingWithChildren[],
    baseDragIndex?: number,
    dragIndex?: number,
  ) => JSX.Element[];
  canAddNewOffering: boolean;
}

export const QuoteFormOfferingTableContent = ({
  quoteOfferings,
  quote,
  onChange,
  quotePrices,
  renderQuoteOfferings,
  canAddNewOffering,
}: QuoteFormOfferingRowProps) => {
  return (
    <>
      <QuoteFormOfferingTableHeader />
      <MBox>{renderQuoteOfferings(quoteOfferings)}</MBox>

      {/* Empty quote offering used to allow user to add a new offering */}
      {canAddNewOffering && (
        <QuoteOffering
          quotePrices={quotePrices}
          onChange={onChange}
          index={-1}
          quoteOfferings={quoteOfferings}
        />
      )}
    </>
  );
};
